



























































import { bookModelProvider } from '../model'
import { defineClassComponent } from '@/hooks'
import { navigateTo } from '@/router'
import { ref } from '@vue/composition-api'

export default defineClassComponent(
  () =>
    class {
      bookModel = bookModelProvider.inject()

      isFold = ref(true)

      handleFoldClick = () => {
        this.isFold.value = !this.isFold.value
      }

      handleBuyClick = (id: string) => {
        navigateTo('BookGoodsIndex', {
          goodsId: id,
        })
      }
    },
)
